import { style } from '@angular/animations';
import { DizionarioModel } from '../../models/shared/dizionario.model';
import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
// import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { MdSnackBar } from "@angular/material";
import { AppComponent } from '../../app.component';
import { IResetRecoverModel } from "../../models/account/ilogin-reset-recover.model";
import { AuthService } from './../../services/auth.service';


@Component({
  selector: 'account-reset',
  moduleId: module.id,
  templateUrl: './account-reset.component.html',
  styles: ['.loginbox { min-width: 320px; max-width: 360px; margin: 0 auto;}']
})
export class AccountResetComponent implements OnInit {
  model: any = {};
  loading = false;
  tokenReset: string;
  resetForm: FormGroup;
  ruoli: DizionarioModel[] = null;
  resetModel: IResetRecoverModel;
  userId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthService,
    private formBuilder: FormBuilder,
    private snackBar: MdSnackBar,
    private _vcr: ViewContainerRef,
    private appComponent: AppComponent) {

  }

  ngOnInit() {
    // reset login status
    this.authenticationService.logout(false);
    this.buildForm();
    // token per il reset '/'
    this.tokenReset = this.route.snapshot.queryParams['code'] || '';
    this.userId = this.route.snapshot.queryParams['UserId'] || '';
  }

  onSubmit() {

    this.loading = true;

    if (this.resetForm) {

      let isCorrectForm = this.resetForm.get("confermaPassword").value === this.resetForm.get("newPassword").value;
      if (isCorrectForm == false) {
        this.loading = false;
        this.showError(" la conferma password non coincide con la password inserita");
        return false;
      }
      //chiamare il metodo di rest password
      this.resetForm.value as IResetRecoverModel;
      this.resetModel = new IResetRecoverModel();
      this.resetModel.code = this.tokenReset;
      this.resetModel.nuovaPassword = this.resetForm.get("newPassword").value;
      this.resetModel.userId = this.userId;
      console.log("User id: "+this.userId);
      this.authenticationService.resetRecoverPassword(this.resetModel)
        .finally(() => {
          this.loading = false;
        })
        .subscribe(
        (data: any) => {
          //verifica esito
          if (data.passwordHasBeenChanged) {
            this.showWarning(data.messaggio);
            this.router.navigate(['/login']);
          } else {
            this.showError(data.messaggio);
          }
        },
        error => {
          this.showWarning(error);
        });
    }
  }

  private showError(message: string) {
    this.snackBar.open("Errore: " + message, 'Chiudi', { duration: 2000 });
    console.log(message);
  }

  private showWarning(message: string) {
    this.snackBar.open(message, 'Chiudi', { duration: 2000 });
    console.log(message);
  }

  buildForm(): void {
    this.resetForm = this.formBuilder.group({
      newPassword: [null, Validators.required],
      confermaPassword: [null, Validators.required]
    });

  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/account/account-reset.component.ts